import React from 'react';
import { STUDIO_COPY } from '../config';
import { REEL_NAME_MAX_LENGTH, isReelNameValid } from '../utils/reelName';

type ReelNameFieldProps = {
  value: string;
  onChange: (next: string) => void;
  id?: string;
  disabled?: boolean;
  showError?: boolean;
  label?: string;
  hideLabel?: boolean;
};

const ReelNameField: React.FC<ReelNameFieldProps> = ({
  value,
  onChange,
  id = 'studio-reel-name',
  disabled = false,
  showError = false,
  label = STUDIO_COPY.reelNameLabel,
  hideLabel = false,
}) => {
  const invalid = showError && !isReelNameValid(value);
  return (
    <div className="studio-reel-name-field" data-testid="studio-reel-name-field">
      <label
        htmlFor={id}
        className={hideLabel ? 'sr-only' : 'studio-reel-name-label'}
      >
        {label}
      </label>
      <input
        id={id}
        type="text"
        className="studio-input"
        value={value}
        maxLength={REEL_NAME_MAX_LENGTH}
        placeholder={STUDIO_COPY.reelNamePlaceholder}
        autoComplete="off"
        disabled={disabled}
        data-testid="studio-reel-name"
        aria-required="true"
        aria-invalid={invalid}
        onChange={(e) =>
          onChange(e.target.value.replace(/[\r\n]/g, ' ').slice(0, REEL_NAME_MAX_LENGTH))
        }
      />
      {invalid ? (
        <p
          className="text-sm text-[var(--studio-danger)]"
          role="alert"
          data-testid="studio-reel-name-error"
        >
          {STUDIO_COPY.reelNameRequired}
        </p>
      ) : null}
    </div>
  );
};

export default ReelNameField;
